import { FC } from 'react'
import styled from 'styled-components'

import CheckmarkIcon from '../../../assets/images/checkmarkIcon.svg'
import { Text } from '@tuhi/components'

const Container = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`

export interface IconAndTextProps {
    text: string
}

export const IconAndTextSpan: FC<IconAndTextProps> = ({ text }) => {
    return (
        <Container>
            <CheckmarkIcon />
            <Text size="large" $weight="regular">
                {text}
            </Text>
        </Container>
    )
}
